import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0212 from "../../../lesson/course-02/lesson-12/lesson";
import lesson0215 from "../../../lesson/course-02/lesson-15/lesson";
import lesson0217 from "../../../lesson/course-02/lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "fc67851c-7c94-4f8b-b410-20ae3c8de958",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
  {
    id: "537a56d9-5306-4382-86cd-1b7e706a8993",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0215),
    lesson: lesson0215,
  },
  {
    id: "53a431e2-7f13-4ed3-b43b-ed2112fcb89e",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0217),
    lesson: lesson0217,
  },
];

export default lessonLinks;
